import type { ReactNode } from "react";
import { PageHeader, PageHeaderTabs } from "@knowtex-ai/components";

export type McSection = "runs" | "playbooks" | "memory" | "issues" | "settings";

const SECTIONS: { id: McSection; label: string }[] = [
  { id: "runs", label: "Runs" },
  { id: "playbooks", label: "Playbooks" },
  { id: "memory", label: "Memory" },
  { id: "issues", label: "Issues" },
  { id: "settings", label: "Settings" },
];

export const sectionPath = (section: McSection) => `/mc/${section}`;

/** The header every MC section shares, with a tab per section. */
export default function McHeader({
  section,
  actions,
}: {
  section: McSection;
  actions?: ReactNode;
}) {
  return (
    <PageHeader
      title="MC – autonomous QA agent"
      subtitle="Agentic QA runs on the webapp against gov-nonprod"
      actions={actions}
      tabs={
        <PageHeaderTabs
          aria-label="MC sections"
          size="medium"
          currentPath={sectionPath(section)}
          tabs={SECTIONS.map(({ id, label }) => ({
            id,
            label,
            to: sectionPath(id),
          }))}
        />
      }
    />
  );
}
